import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { BrandService } from '../brand.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {
  constructor(
    private brandService: BrandService,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService
  ) {}

  @Input() control: UntypedFormControl | undefined;

  @Input() dialogRef: MatDialogRef<CreateComponent, any> | undefined;

  formGroup = this.fb.group({
    description: new UntypedFormControl(),
    oe: new UntypedFormControl()
  });

  ngOnInit(): void {
    if (this.control) this.descriptionFormControl.setValue(this.control.value);
  }

  get descriptionFormControl() {
    return this.formGroup.controls.description as UntypedFormControl;
  }

  get oeFormControl() {
    return this.formGroup.controls.oe as UntypedFormControl;
  }

  get description() {
    return this.formGroup.controls.description.value;
  }

  get oe() {
    return this.formGroup.controls.oe.value;
  }

  create() {
    this.brandService.create(this.description, this.oe).subscribe((newBrand) => {
      if (this.control) this.control.setValue(newBrand);
      if (this.dialogRef) this.dialogRef.close();
      this.notificationService.notice(`Производитель ${newBrand.description} создан!`);
    });
  }
}
